import { erpClient } from '@tfpl/api-client';

export const getCollaboratorFullName = (collaboratorProfile: erpClient.CollaboratorProfileOutputDto) => {
  return `${collaboratorProfile.collaborator.firstName} ${collaboratorProfile.collaborator.lastName}`;
};
